import { useWatchlist } from "@/context/WatchlistContext";
import { Star } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function WatchButton({ kind, id, city, size = "sm", label = false, className = "" }) {
  const { has, toggle } = useWatchlist();
  const saved = has(kind, id);
  const onClick = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      await toggle(kind, id, city);
      toast.success(saved ? "Rimosso dai preferiti" : "Aggiunto ai preferiti");
    } catch {
      toast.error("Errore nel salvataggio");
    }
  };
  const iconSize = size === "sm" ? 14 : 16;
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 px-2 h-8 border font-mono-data text-[11px] transition-colors ${
        saved
          ? "bg-lime-400/20 text-lime-400 border-lime-400/50 hover:bg-lime-400/30"
          : "bg-transparent text-zinc-400 border-white/10 hover:bg-white/5 hover:text-lime-400"
      } ${className}`}
      data-testid={`watch-btn-${kind}-${id}`}
      aria-label={saved ? "Rimuovi dai preferiti" : "Aggiungi ai preferiti"}
      title={saved ? "Rimuovi dai preferiti" : "Aggiungi ai preferiti"}
    >
      <Star size={iconSize} weight={saved ? "fill" : "bold"} />
      {label && <span>{saved ? "Salvato" : "Salva"}</span>}
    </button>
  );
}
